export const paths = {
  left: [
    [
      {
        x: 620,
        y: 353
      },
      {
        x: 850,
        y: 353
      },
      {
        x: 850,
        y: 245
      }
    ],
    [
      {
        x: 620,
        y: 353
      },
      {
        x: 850,
        y: 353
      },
      {
        x: 850,
        y: 100
      }
    ],
    [
      {
        x: 792,
        y: 470
      },
      {
        x: 792,
        y: 353
      }
    ],
    [
      {
        x: 924,
        y: 470
      },
      {
        x: 924,
        y: 353
      },
      {
        x: 850,
        y: 353
      }
    ],
    [
      {
        x: 1150,
        y: 353
      },
      {
        x: 924,
        y: 353
      }
    ]
  ],
  right: [
    [
      {
        x: 600,
        y: 353
      },
      {
        x: 277,
        y: 353
      },
      {
        x: 277,
        y: 176
      }
    ],
    [
      {
        x: 343,
        y: 490
      },
      {
        x: 343,
        y: 355
      }
    ],
    [
      {
        x: 211,
        y: 481
      },
      {
        x: 211,
        y: 355
      }
    ],
    [
      {
        x: 118,
        y: 288
      },
      {
        x: 119,
        y: 355
      }
    ],
    [
      {
        x: 77,
        y: 355
      },
      {
        x: 275,
        y: 355
      }
    ]
  ]
};

export const polygons = {
  left: {
    type: 'polygon',
    points: [
      {
        x: 206.4379507014643,
        y: 175.52026235633784
      },
      {
        x: 206.4379507014643,
        y: 192.4953349479694
      },
      {
        x: 255.18687711845757,
        y: 192.71296408375957
      },
      {
        x: 254.96369536167606,
        y: 335.11093104241087
      },
      {
        x: 264.3646965969555,
        y: 335.11093104241087
      },
      {
        x: 264.33771264982005,
        y: 343.0217257848219
      },
      {
        x: 76.00096535578885,
        y: 343.2241628359591
      },
      {
        x: 75.56329378837619,
        y: 365.98308434141774
      },
      {
        x: 192.64043807126447,
        y: 365.7642485577114
      },
      {
        x: 193.07810963867715,
        y: 364.01356228806077
      },
      {
        x: 198.98667579874814,
        y: 364.01356228806077
      },
      {
        x: 199.15588071334494,
        y: 488.65974239970024
      },
      {
        x: 221.87712713569786,
        y: 488.9368307707045
      },
      {
        x: 221.7455973042068,
        y: 366.2019201251241
      },
      {
        x: 330.9446533736671,
        y: 365.7642485577114
      },
      {
        x: 331.6041220534022,
        y: 489.2139191417088
      },
      {
        x: 354.0482801047508,
        y: 488.9368307707045
      },
      {
        x: 353.9224106628321,
        y: 364.67006963917976
      },
      {
        x: 564.8619807601087,
        y: 365.4909501193706
      },
      {
        x: 564.8619807601087,
        y: 383.8793338069508
      },
      {
        x: 602.7332947833394,
        y: 383.8793338069508
      },
      {
        x: 602.5143854537253,
        y: 343.1621984987375
      },
      {
        x: 536.6176923706488,
        y: 343.38381212945677
      },
      {
        x: 432.83063873316354,
        y: 343.75985217886796
      },
      {
        x: 358.7507489991614,
        y: 343.38381212945677
      },
      {
        x: 297.08018089572806,
        y: 343.00777208004564
      },
      {
        x: 285.7989794133927,
        y: 343.00777208004564
      },
      {
        x: 285.4402304714438,
        y: 334.5899142104428
      },
      {
        x: 289.93541995691567,
        y: 334.3588509435885
      },
      {
        x: 290.87805538804196,
        y: 175.52026235633784
      }
    ],
    property: {
      name: '选区2',
      offset: [30, 5],
      strokeColor: '#f00',
      fillColor: 'transparent',
      lineWidth: 2,
      seeds: [[275, 300, 'red']]
    }
  },
  right: {
    type: 'polygon',
    points: [
      {
        x: 611.0168626464477,
        y: 343.60824436236146
      },
      {
        x: 834.8815637176735,
        y: 342.79903779050295
      },
      {
        x: 843.8667539944024,
        y: 342.9817112214081
      },
      {
        x: 844.0801239952766,
        y: 335.30039118993756
      },
      {
        x: 835.5453239603094,
        y: 335.08702118906336
      },
      {
        x: 835.4347935922058,
        y: 192.70767696329386
      },
      {
        x: 786.4821733822675,
        y: 192.50370771241913
      },
      {
        x: 786.2782041313928,
        y: 175.37029063894076
      },
      {
        x: 871.5389393537445,
        y: 175.63938258831243
      },
      {
        x: 871.2806748848234,
        y: 192.94310200602663
      },
      {
        x: 871.1294124952857,
        y: 195.97118497728974
      },
      {
        x: 871.1781141062976,
        y: 334.66028118731504
      },
      {
        x: 866.4839740870656,
        y: 334.8736511881892
      },
      {
        x: 866.6034370843896,
        y: 343.0864928084637
      },
      {
        x: 943.3252466337007,
        y: 342.79903779050295
      },
      {
        x: 1181.3452275981087,
        y: 343.3551592413544
      },
      {
        x: 1180.7891061472574,
        y: 366.15613872626267
      },
      {
        x: 940.9449413516041,
        y: 365.91295359856707
      },
      {
        x: 940.359367387675,
        y: 363.2778707608862
      },
      {
        x: 933.6252668024904,
        y: 363.2778707608862
      },
      {
        x: 933.3324798205258,
        y: 367.6696754903544
      },
      {
        x: 933.6601084533442,
        y: 499.81380963437744
      },
      {
        x: 911.6512010102165,
        y: 499.4352792996232
      },
      {
        x: 911.6512010102165,
        y: 365.0290261192314
      },
      {
        x: 800.9636983910702,
        y: 364.6852761110974
      },
      {
        x: 801.3074483992043,
        y: 500.1227793158912
      },
      {
        x: 779.3074478786286,
        y: 500.4665293240252
      },
      {
        x: 779.2655103776361,
        y: 365.259544874686
      },
      {
        x: 662.8897701238918,
        y: 365.9361480156961
      },
      {
        x: 662.8897701238918,
        y: 383.3022953016231
      },
      {
        x: 611.2423970267844,
        y: 383.0767609212864
      }
    ],
    property: {
      name: '选区2',
      offset: [30, 5],
      strokeColor: '#f00',
      fillColor: 'transparent',
      lineWidth: 2,
      seeds: [[855, 255, 'red']]
    }
  }
};

export function getMockData(dirc) {
  return {
    paths: paths[dirc],
    polygons: polygons[dirc]
  };
}
